import { render, staticRenderFns } from "./LaosAsean.vue?vue&type=template&id=6d68402e&"
import script from "./LaosAsean.vue?vue&type=script&lang=js&"
export * from "./LaosAsean.vue?vue&type=script&lang=js&"
import style0 from "./LaosAsean.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports